import { Box } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/react";
import type { WithIdProps } from "@src/components/HOC/with-id/withId";
import { Card } from "@src/components/ui-kit";
import { NavigationProject } from "@src/components/widgets/AppSubNav";

export const ProjectDetailLoading = ({ id }: WithIdProps) => {
  return (
    <Card overflow="hidden">
      <Box px="4" borderBottomWidth="thin">
        <NavigationProject id={id} />
      </Box>

      <Skeleton minH="50dvh" />
    </Card>
  );
};
